'use client'

import { useEffect, useState, Suspense, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

function ProgressBar() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const prevPathRef = useRef<string>('')
  const prevSearchRef = useRef<string>('')

  useEffect(() => {
    const currentPath = pathname
    const currentSearch = searchParams.toString()
    
    // 只在路由真正变化时才触发进度条
    if (prevPathRef.current === currentPath && prevSearchRef.current === currentSearch) {
      return
    }
    
    prevPathRef.current = currentPath
    prevSearchRef.current = currentSearch

    // 开始加载
    setLoading(true)
    setProgress(20)
    
    // 模拟加载进度
    const timer = setTimeout(() => {
      setProgress(90)
    }, 100)

    // 完成加载
    const completeTimer = setTimeout(() => {
      setProgress(100)
      setTimeout(() => {
        setLoading(false)
        setProgress(0)
      }, 200)
    }, 300)

    return () => {
      clearTimeout(timer)
      clearTimeout(completeTimer)
    }
  }, [pathname, searchParams])

  if (!loading) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-1 bg-gray-200">
      <div
        className="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}

export function RouteProgressBar() {
  return (
    <Suspense fallback={null}>
      <ProgressBar />
    </Suspense>
  )
}